const CALL_MIN_HEIGHT = 480;
const CALL_CHROME_HEIGHT = 120;
const VIEWPORT_MARGIN = 96;
const STAGE_ASPECT = 9 / 16;

function roomMinHeightFor({ optionMinHeight = 0, surfaceWidth = 0, viewportHeight = 0, hasJoined = false }) {
  const floor = Number(optionMinHeight) || 0;
  if (!hasJoined) {
    return floor;
  }
  const wanted = Math.round((Number(surfaceWidth) || 0) * STAGE_ASPECT) + CALL_CHROME_HEIGHT;
  const ceiling = viewportHeight > 0 ? Math.max(CALL_MIN_HEIGHT, viewportHeight - VIEWPORT_MARGIN) : Number.POSITIVE_INFINITY;
  const fitted = Math.min(Math.max(wanted, CALL_MIN_HEIGHT), ceiling);

  return Math.max(fitted, floor);
}

module.exports = {
  CALL_MIN_HEIGHT,
  roomMinHeightFor,
};
